
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorials/[slug]",
      function () {
        return require("private-next-pages/editorials/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorials/[slug]"])
      });
    }
  